import React from 'react';
import styled from 'styled-components';
import Modal from 'react-modal';
import { Times } from '@styled-icons/fa-solid/Times';
import { ExclamationTriangle } from '@styled-icons/fa-solid/ExclamationTriangle';
import { device } from '../../constants/device-sizes';
import ModalButton from './ModalButton';
import TitleText from './TitleText';

const CloseButton = styled(Times)`
  cursor: pointer;
  position: absolute;
  width: 2.5rem;
  height: 2.5rem;
  top: 1rem;
  right: 1rem;
  margin: 1rem 1rem;
  font-size: 2rem;
  transition: all 0.2s linear;
  color: var(--clr-sec);
  :hover {
    color: red;
  }
`;

const ModalWrapper = styled.div`
  width: 100%;
  padding: 1rem;
  @media ${device.tablet} {
    width: 50%;
    position: auto;
    top: auto;
  }
  top: 0px;
  position: absolute;
`;

const ModalContent = styled.div`
  padding: 16px;
  background-color: var(--clr-bg);
  width: 100%;
  border-radius: 12px;
  shadow-opacity: 0.18;
  shadow-radius: 4px;
  shadow-color: #000;
  shadow-offset: 0px 4px;
  elevation: 10;
`;

const Description = styled.p`
  color: var(--clr-sec);
  font-size: 16px;
  text-align: center;
  margin: 1.5rem 0;
  line-height: 1.5;
`;

const SolutionList = styled.ul`
  color: var(--clr-sec);
  font-size: 14px;
  margin: 1.5rem 0;
  padding-left: 1.5rem;

  li {
    margin-bottom: 0.5rem;
    line-height: 1.4;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
`;

const ModalButtonSC = styled.div`
  cursor: pointer;
  flex-grow: 1;
  margin: 0 0.5rem;
`;

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 1rem 0;
  color: var(--clr-orange);
`;

const CaptchaErrorModal = ({ visible, onClose, onRefresh, errorData }) => {
  return (
    <Modal
      isOpen={visible}
      onRequestClose={onClose}
      style={{
        overlay: { zIndex: 1000, backgroundColor: 'rgba(0,0,0,0.5)' },
        content: {
          background: 'none',
          border: 'none',
          padding: 0,
          inset: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        },
      }}
      ariaHideApp={false}
    >
      <ModalWrapper>
        <ModalContent>
          <CloseButton onClick={onClose} />

          <TitleText>The recaptcha system thinks you're a bot</TitleText>

          <IconContainer>
            <ExclamationTriangle size={48} />
          </IconContainer>

          <Description>
            Recaptcha tries to automatically detect bots and it detected you as
            a bot, so your message wasn't sent. If you are not a bot, here are
            some things to try to fix this:
          </Description>

          <SolutionList>
            <li>
              Try clicking around the site a bit before sending your next
              message so recaptcha doesn't think you're a bot
            </li>
            <li>Only have one tab of VentScape open at a time</li>
            <li>Disable browser extensions that might block verification</li>
            <li>
              If this issue still persists, add gabetheventscapedev on Discord
              and tell me so I can try to fix it!
            </li>
          </SolutionList>

          <ButtonContainer>
            <ModalButtonSC
              width='45%'
              as={ModalButton}
              isAffirmative={false}
              onClick={onClose}
            >
              Close
            </ModalButtonSC>
          </ButtonContainer>
        </ModalContent>
      </ModalWrapper>
    </Modal>
  );
};

export default CaptchaErrorModal;
